import { enableFamilyInviteV2Flow } from "config";

import StudentContent from "./StudentContent";
import StudentContentV2 from "./StudentContentV2";

export default enableFamilyInviteV2Flow ? StudentContentV2 : StudentContent;
